/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:54:24
 * @LastEditTime: 2023-03-02 17:51:37
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-statistic-analy\modules\serviceFlowDimensionRouter.js
 * 服务商流向维度
 */

// 和代理商流向维度共用一套路由
const serviceFlowDimensionRouter = []
export default serviceFlowDimensionRouter
